<template>
  <div class="ali-player">
    
    <div class="video-box" v-if="showVideo">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        @ready="onPlayerReadied"
        @error="onError($event)"
        @pause="onPause"
        @play="onPlay"
        @timeupdate="onTimeupdate"
        @loadeddata="onPlayerLoadeddata"
        x5-playsinline
        webkit-playsinline
        playsinline
        x-webkit-airplay="allow"
        x5-video-player-type="h5"
      >
      </video-player>
      <div class="control-box">
        <!-- 进度条 -->
        <div class="video-progress">
          <el-slider
            v-model="sliderTime"
            :format-tooltip="formatProcessToolTip"
            @change="changeCurrentTime"
            class="slider"
          ></el-slider>
        </div>
        <!-- 播放控件 -->
        <div class="video-control">
          <div class="control-left">
            <div class="video-btn">
              <el-button
                v-if="!this.video.playing"
                type="text"
                @click="play"
              ><img :src="require('@/assets/img/playerimg/palying.png')" title="播放"/></el-button>
              <el-button
                v-else
                type="text"
                @click="pause"
              ><img :src="require('@/assets/img/playerimg/pause.png')" title="暂停"/></el-button>
            </div>
            <p class="video-time">
              <span>{{realFormatSecond(this.video.currentTime)}}</span>
            </p>
          </div>
          <div class="control-right">
            <!-- 时移 -->
            <!-- 分辨率 -->
            <div class="ratio" v-if="sourceListUrl">
              <el-popover
               placement="top"
               popper-class="ratio-popover"
               :visible-arrow="true"
               trigger="hover">
                <ul class="ratio-list">
                  <li  v-for="(item,index) in sourceListUrl" :key="index"
                    :class="index==ratioIndex?'is-active':''"
                    @click="setRatio(item,index)">
                    {{item.resolutionName}}
                  </li>
                </ul>
                <div class="news-ratio" slot="reference">{{newRatio.resolutionName}}</div>
              </el-popover>
            </div>
            <!-- 音量 -->
            <div class="video-sound" >
              <div
                id="player_sound_btn_player"
                volume="50"
                ismute="false"
                @click="showSound"
                @mouseenter="showMouse=true"
                @mouseleave="showMouse=false">
                <img
                  v-if="!sound && !showMouse"
                  id="player_sound_yes_player"
                  src="@/assets/img/playerimg/sound.png"
                >
                <img
                  v-if="sound&&!showMouse"
                  id="player_sound_no_player"
                  src="@/assets/img/playerimg/sound-no.png"
                >
                <img
                  v-if="!sound&&showMouse"
                  id="player_sound_yes_player"
                  src="@/assets/img/playerimg/sound-hover.png"
                >
                <img
                  v-if="sound&&showMouse"
                  id="player_sound_yes_player"
                  src="@/assets/img/playerimg/sound-no-hover.png"
                >
                
              </div>
              <el-slider v-if="!sound"
                class="sound-slider"
                vertical
                style="height:100PX;cursor:pointer"
                v-model="soundValue"
                @change="getChange"
              ></el-slider>
            </div>
            <!-- 画中画 -->
            <div class="pictureInPicture" @click="openPicInpic"  @mouseenter="InPicture=true"
                @mouseleave="InPicture=false">
              <img v-if="inpic==true&& !InPicture" :src="require('@/assets/img/playerimg/outpic.png')" title="画中画"/>
              <img v-if="inpic==true&& InPicture" :src="require('@/assets/img/playerimg/outpic.png')" title="画中画"/>
              <img v-if="inpic==false&& !InPicture" :src="require('@/assets/img/playerimg/picInpic.png')" title="画中画"/>
              <img v-if="inpic==false&& InPicture" :src="require('@/assets/img/playerimg/inpic.png')" title="画中画"/>
            </div>
            <!-- 全屏 -->
            <div class="full-screen" @click="openFullscreen" @mouseenter="InFullscreen=true"
                @mouseleave="InFullscreen=false">
              <img v-if="!InFullscreen" :src="require('@/assets/img/playerimg/fullscreen.png')" title="全屏"/>
               <img v-else :src="require('@/assets/img/playerimg/inFullscreen.png')" title="全屏"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="zhanwei" v-if="!showVideo">
      <!-- <img :src="cont.iconPath||require('@/assets/img/amg/loding.gif')" alt=""> -->
      <div class="playbtn" v-if="!showVideo">
        <i class="begin-play" @click="play"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-contrib-hls'
export default {
  name: "",
  components: { videoPlayer },
  props: ['sourceUrl','sourceListUrl'],
  data () {
    return {
      showVideo:false,
      newRatio:{},
      ratioIndex:0,
      InPicture:false,
      InFullscreen:false,
      inpic:false, // 画中画false展示未进入状态,点击进入
      showMouse:false,
      followBtn:false,
      newSoundValue: 75,
      soundValue:75,
      sound:false,
      sliderTime: 0,
      video: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        // 音频当前播放时长
        currentTime: 0,
        // 音频最大播放时长
        maxTime: 0,
      },
      audioDetail: {},
      videoInfo: {
        time: 0,
      },
      progressing_audio: 0,
      loading: true,
      playerOptions: {
        autoplay: true, //如果true,浏览器准备好时开始回放。(好像微信浏览器不太行)
        techOrder: ['html5'], // 需要加载的插件，如果是要兼容flash的话，必须先加载flash。顺序不能错：['flash','html5']
        flash: {
          hls: { withCredentials: false }
        },
        html5: { hls: { withCredentials: false } },
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        language: 'zh-CN', // 提示的语言 中文的话是 zh-CN
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度 0.7倍...
        sources: [
          {
            withCredentials: false, // 直播是否有播放令牌，反正我是没有
            type: "application/x-mpegURL"||'video/x-flv'||'rtmp/mp4'||'video/mp4'||'video/webm'||'video/ogg'||'video/avi'||'rm/wmv',
            src: "",
          },
        ],
        poster: '', //你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controls: false, // 是否显示操作条
        controlBar: {
          // 播放的操作
          timeDivider: false, // 时间分割线
          durationDisplay: false, // 总时间
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    },
    currentStream () {
      return this.currentTech === 'Flash' ? 'RTMP' : 'HLS'
    }
  },
  mounted () {
    if (this.sourceUrl) {
      let sourceUrl=''
      if (typeof this.sourceUrl == 'string') {
          sourceUrl=this.sourceUrl
        }
       
      var index = sourceUrl.lastIndexOf(".");
      var ext = sourceUrl.substr(index + 1);
      var ipos = ext.indexOf("?")||ext;//指定开始的字符串
      let str1 =ipos==-1?ext:ext.substring(0,ipos); //取前部分（指定开始的字符串的之前
     
      if(str1 == 'm3u8') {
        this.playerOptions.sources[0].type = 'application/x-mpegURL'
      }else if(ext == 'flv') {
        this.playerOptions.sources[0].type = 'video/x-flv'
      }else if(ext == 'mov') {
        this.playerOptions.sources[0].type = 'rtmp/mp4'
      }else if(ext == 'mp4'){
        this.playerOptions.sources[0].type = 'video/mp4'
      }
       this.playerOptions.sources[0].src = sourceUrl
    }
    if (this.sourceListUrl) {
      this.newRatio = this.sourceListUrl[0]
      this.ratioIndex = 0
      var url = this.newRatio.resolutionPath
      var index = url.lastIndexOf(".");
      var ext = url.substr(index + 1);
      var ipos = ext.indexOf("?") || ext; //指定开始的字符串
      let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
      if (str1 == "m3u8") {
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      } else if (ext == "flv") {
        this.playerOptions.sources[0].type = "video/x-flv";
      } else if (ext == "mov") {
        this.playerOptions.sources[0].type = "rtmp/mp4";
      }else if(ext == 'mp4'){
        this.playerOptions.sources[0].type = 'video/mp4'
      }
      this.playerOptions.sources[0].src = url
    }
  },
  watch: {
    sourceUrl(newValue) {
      let sourceUrl=''
      if (newValue) {
        if (typeof newValue == 'string') {
          sourceUrl=newValue
        }
        
        var index = sourceUrl.lastIndexOf(".");
        var ext = sourceUrl.substr(index + 1);
        var ipos = ext.indexOf("?") || ext; //指定开始的字符串
        let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
        if (str1 == "m3u8") {
          this.playerOptions.sources[0].type = "application/x-mpegURL";
        } else if (ext == "flv") {
          this.playerOptions.sources[0].type = "video/x-flv";
        } else if (ext == "mov") {
          this.playerOptions.sources[0].type = "rtmp/mp4";
        } else if(ext == 'mp4'){
          this.playerOptions.sources[0].type = 'video/mp4'
        }
        this.playerOptions.sources[0].src = newValue
      }else{
        // this.playerOptions.sources[0].type = "video/mp4";
        this.playerOptions.sources[0].src = ''
      }
      
    },
    sourceListUrl(newValue){
       this.newRatio = newValue[0]
       this.ratioIndex = 0
       var url = this.newRatio.resolutionPath
       var index = url.lastIndexOf(".");
       var ext = url.substr(index + 1);
       var ipos = ext.indexOf("?") || ext; //指定开始的字符串
       let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
       if (str1 == "m3u8") {
         this.playerOptions.sources[0].type = "application/x-mpegURL";
       } else if (ext == "flv") {
         this.playerOptions.sources[0].type = "video/x-flv";
       } else if (ext == "mov") {
         this.playerOptions.sources[0].type = "rtmp/mp4";
       } else if(ext == 'mp4'){
          this.playerOptions.sources[0].type = 'video/mp4'
       }
       this.playerOptions.sources[0].src = url
    },
  },
  methods: {
    // 切换清晰度
    setRatio (item,index) {
      this.newRatio = item
      this.ratioIndex = index
      var url = item.resolutionPath
       var index = url.lastIndexOf(".");
       var ext = url.substr(index + 1);
       var ipos = ext.indexOf("?") || ext; //指定开始的字符串
       let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
       if (str1 == "m3u8") {
         this.playerOptions.sources[0].type = "application/x-mpegURL";
       } else if (ext == "flv") {
         this.playerOptions.sources[0].type = "video/x-flv";
       } else if (ext == "mov") {
         this.playerOptions.sources[0].type = "rtmp/mp4";
       } else {
         this.playerOptions.sources[0].type = "video/mp4";
       }
       this.playerOptions.sources[0].src = url
      //  console.log(this.playerOptions.sources);
    },
    // 画中画
    openPicInpic () {
      let video = document.querySelector('.vjs-tech')
      var that = this
      video.addEventListener('enterpictureinpicture', function() {
         that.inpic=true
      });
      video.addEventListener('leavepictureinpicture', function() {
        that.inpic=false
      });
      if (video !== document.pictureInPictureElement) {
        this.player.requestPictureInPicture()
      }else{
        document.exitPictureInPicture();
      }
    },
    openFullscreen () {
      this.player.requestFullscreen()
    },
    onPlayerReadied () {
      if (!this.initialized) {
        this.initialized = true
        this.currentTech = this.player.techName_
      }
    },
    changeTech () {
      if (this.currentTech === 'Html5') {
        this.playerOptions.techOrder = ['html5']
      } else if (this.currentTech === 'Flash') {
        this.playerOptions.techOrder = ['flash']
      }
      this.playerOptions.autoplay = true
    },
    onError () {
      // this.$message.warning('播放错误!')
    },
    // 时间
    realFormatSecond(second) {
      var secondType = typeof second
      if (secondType === 'number' || secondType === 'string') {
        second = parseInt(second)
        var hours = Math.floor(second / 3600)
        second = second - hours * 3600
        var mimute = Math.floor(second / 60)
        second = second - mimute * 60
          return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
        // return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
      } else {
        return '00:00'
      }
    },

    // 播放
    play() {
      this.showVideo=true
      setTimeout(() => {
        this.$refs.videoPlayer.player.play();
        this.timer = setInterval(() => {
          this.progressing_audio =
            (this.progressing_audio / 100 + 0.1 / this.video.maxTime) * 100;
          this.second = this.second + 0.1;
          if (this.progressing_audio >= 100) {
            clearInterval(this.timer);
            this.progressing_audio = 0;
            this.second = 0;
          }
        }, 100);
      }, 500);
      
    },
    // 暂停
    pause() {
      this.$refs.videoPlayer.player.pause();
      clearInterval(this.timer)
    },
    // 当播放
    onPlay() {
      this.video.playing = true;
    },
    // 当暂停
    onPause() {
      this.video.playing = false;
    },
    // 进度条toolTip
    formatProcessToolTip(index) {
      index = parseInt(this.video.maxTime / 100 * index)
      return '进度条: ' + this.realFormatSecond(index)
    },
    // 播放跳转
    changeCurrentTime(index) {
    //  this.player.cache_.currentTime = parseInt(index / 100 * this.video.maxTime)
      this.player.currentTime(parseInt(index / 100 * this.video.maxTime))
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      this.video.currentTime = res.cache_.currentTime;
      this.sliderTime = this.video.currentTime / this.video.maxTime * 100
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onPlayerLoadeddata(res) {
      this.videoInfo.time = this.realFormatSecond(parseInt(res.cache_.duration));
      this.video.maxTime = parseInt(res.cache_.duration);
    },
    showSound () { //声音
      this.sound = !this.sound
      if (this.sound) {
        this.soundValue = 0
        this.player.cache_.lastVolume = this.soundValue / 100
        this.player.volume(this.player.cache_.lastVolume)
      } else {
        this.soundValue = this.newSoundValue
        this.player.cache_.lastVolume = this.soundValue / 100
        this.player.volume(this.player.cache_.lastVolume)
      }
    },
    getChange () {
      this.sound = false
      this.newSoundValue = this.soundValue
      this.player.cache_.volume = this.newSoundValue / 100
    },
  },
  beforeDestroy () {
  },
};
</script>
<style lang="css" scoped>
.video-btn >>> .el-button--text{
  padding: 0PX;
  font-size: 14PX;
}
.ali-player {
  width: 100%;
  height: 100%;
  position: relative;
}
.video-box,.video-player{
  width: 100%;
  height: 100%;
}
.zhanwei{
  width: 100%;
  height: 100%;
  background-color: #000;
  background-image: url("../../assets/img/jingcaiz.png");
  background-size: 100% 100%;
  background-position: center;
  position: relative;
}
.zhanwei img{
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}
.playbtn {
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-image: url("../../assets/img/playbg.png");
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.playbtn .begin-play {
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
.control-box{
  position: absolute;
  bottom: 0PX;
  left: 0PX;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.video-control{
  display: flex;
  padding: 0 30PX;
  align-items: center;
  justify-content: space-between;
}
.control-left,.control-right{
  display: flex;
  align-items: center;
}
.video-sound{
  position: relative;
}
.video-sound .sound-slider{
  position: absolute;
  top: -130PX;
  left: 20PX;
  /* transform:rotate(-90deg); */
  opacity: 0;
  transition: all .5s linear .5s;
}
.video-sound:hover .video-sound .sound-slider{
  display: block;
  opacity: 1;
}
.video-sound img{
  width: 20PX;
  height: 20PX;
}
.video-sound .sound-slider:hover{
  display: block;
  opacity: 1;
}

#player_sound_btn_player{
  margin-left: 15PX;
  cursor: pointer;
  height: 20PX;
  line-height: 20PX;
}
#player_sound_btn_player:hover + .sound-slider{
  display: block;
  opacity: 1;
}
.video-time{
  color: #fff;
  margin-left: 15PX;
  font-size: 12PX;
}
.video-progress {
  padding: 0 30PX;
  margin: 0 auto;
  margin-bottom: -10PX;
  position: relative;
}
.video-progress >>> .el-slider__runway{
  margin:15PX 0;
  height: 10PX;
}
.sound-slider >>> .el-slider__bar{
  background-color: #3A83FF !important;
  width: 10PX !important;
}
.video-progress >>> .el-slider__bar{
  background-color: #3A83FF !important;
  height: 10PX;
}
.video-progress >>> .el-slider__button-wrapper{
  display: none;
  width: 10PX;
  height: 10PX;
  
}

.video-sound >>> .el-slider.is-vertical .el-slider__runway{
  margin: 0;
  width: 10PX !important;
}
.sound-slider >>> .el-slider__button{
  width: 10PX;
    height: 10PX;
    border: 1PX solid #409EFF;
    margin-left: -1PX;
    margin-top: 1px;
}
.video-progress {
  padding: 0 30PX;
  margin: 0 auto;
  margin-bottom: -10PX;
  position: relative;
}
.ali-player >>> .video-js.vjs-fluid{
  height: 100%;
  padding:0PX;
}
.ali-player >>> .vjs-big-play-button{
  display: none;
}
.sound-slider >>> .el-slider__bar{
  background-color: #3A83FF !important;
}
.video-sound >>> .el-slider.is-vertical .el-slider__button-wrapper{
  width: 10PX;
  height: 25PX;
  left: 0PX;
  margin-top: -5PX;
}
.video-progress >>> .el-slider__bar{
  background-color: #3A83FF !important;
}
.video-progress >>> .el-slider__button-wrapper{
  display: none;
}
.sound-slider >>> .el-slider.is-vertical .el-slider__runway{
  margin: 0;
}
.pictureInPicture img,.full-screen img{
  cursor: pointer;
  display: block;
  width: 20PX;
  height: 20PX;
  margin-left: 20PX;
}
.news-ratio{
  color: #fff;
  font-size: 14PX;
  height: 20PX;
  line-height: 20PX;
}

.ratio-list li{
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 29PX;
  padding-right: 26PX;
  min-width: 99PX;
  position: relative;
  height: 34PX;
  line-height: 34PX;
  margin-top: 7PX;
  border-radius: 17PX;
  opacity: .8;
}
.ratio-list .is-active{
  color: #fff;
  background: hsla(0,0%,100%,.15);
  opacity: 1;
}
</style>
<style>
.ratio-popover{
  padding: 10PX 15PX;
  text-align: center;
  color: #fff;
  background: rgba(17,17,17,.7);
  border-radius: 8PX;
  border: 0PX;
}
.el-tooltip__popper.is-dark{
  padding: 10PX;
  font-size: 12PX;
  border-radius: 5PX;
  min-width: auto;
}
.el-tooltip__popper .popper__arrow{
  display: none !important;
}
</style>

